'use client';

import React, { useEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useRole } from '@/contexts/RoleContext';

interface NavGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps page content and redirects to /executive-dashboard
 * if the current role is not allowed to access the current route.
 */
export default function NavGuard({ children }: NavGuardProps) {
  const { canRoute, role } = useRole();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    if (!canRoute(pathname)) {
      router.replace('/executive-dashboard');
    }
  }, [pathname, canRoute, router]);

  // While the redirect is in flight, render nothing to avoid flash
  if (!canRoute(pathname)) return null;

  return <>{children}</>;
}
